// src/firebase.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyC8MH0KbtIFtPF-7ZG4uJZBKq9DmCcO0ZA",
  authDomain: "imedicate-em.firebaseapp.com",
  databaseURL: "https://imedicate-em-default-rtdb.firebaseio.com",
  projectId: "imedicate-em",
  storageBucket: "imedicate-em.appspot.com", // ✅ fixed
  messagingSenderId: "1008187572199",
  appId: "1:1008187572199:web:3c7f171a39669f3b778742",
  measurementId: "G-QFDLEY117F"
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "us-central1");
export { app };
